import { useContext } from 'react'
import { useSelector } from 'react-redux'

import {
  useForm, useLatestEntity, useThunkDispatch,
} from '@domain-group/react-hooks'

import * as customShortcodeActions from '@redux/modules/customShortcode'

import PageContext from '@contexts/pageContext'

import defaultState, { requiredFields } from '@models/customShortcode'

const createCustomShortcode = (params) => {
  const { customShortcodeParams, dispatch } = params
  const { createCustomShortcode: createFn } = customShortcodeActions

  return dispatch(createFn(customShortcodeParams))
}

const deleteCustomShortcode = (params) => {
  const { customShortcode, dispatch } = params
  const { deleteCustomShortcode: deleteFn } = customShortcodeActions

  return dispatch(deleteFn(customShortcode))
}

const updateCustomShortcode = (params) => {
  const { customShortcodeParams, dispatch } = params
  const { updateCustomShortcode: updateFn } = customShortcodeActions

  return dispatch(updateFn(customShortcodeParams))
}

const createOrEditCustomShortcode = params => (
  new Promise((resolve, reject) => {
    const { customShortcode, showCreateOrEditCustomShortcodeModal } = params

    if (showCreateOrEditCustomShortcodeModal){
      const payload = {
        customShortcode,
      }

      showCreateOrEditCustomShortcodeModal(payload)

      resolve({ success: true, result: payload })
    }

    reject(new Error('showCreateOrEditCustomShortcodeModal not defined in PageContext callbacks'))
  })
)

export function useCustomShortcodeForm(customShortcode = {}, options = {}){
  const { validateOn } = options

  const customShortcodeForm = useForm(
    defaultState,
    { entity: customShortcode, requiredFields, validateOn },
    [customShortcode.id, customShortcode.cache_key],
  )

  return {
    ...customShortcodeForm,
  }
}

const useCustomShortcode = (initEntity = {}) => {
  const { entity: customShortcode } = useLatestEntity(initEntity, 'customShortcodes')
  const dispatch = useThunkDispatch()

  const { callbacks } = useContext(PageContext)
  const { showCreateOrEditCustomShortcodeModal } = callbacks || {}

  const {
    creating, deleting, updating,
  } = useSelector(reduxState => reduxState.customShortcodes)

  return {
    callbacks: {
      createCustomShortcode: customShortcodeParams => createCustomShortcode({ customShortcodeParams, dispatch }),
      createOrEditCustomShortcode: () => (
        createOrEditCustomShortcode({ customShortcode, showCreateOrEditCustomShortcodeModal })
      ),
      deleteCustomShortcode: () => deleteCustomShortcode({ customShortcode, dispatch }),
      updateCustomShortcode: customShortcodeParams => updateCustomShortcode({ customShortcodeParams, dispatch }),
    },
    creating,
    customShortcode,
    deleting,
    updating,
  }
}

export default useCustomShortcode
